import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
import config from "../../config";

export const generatePresignedUrl = createAsyncThunk(
    "upload/generatePresignedUrl",
    async (request, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${config.api.API_URL}/dashboard/upload/presigned-url`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                body: JSON.stringify(request),
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);